<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="table-demo">

        <div class="sticky-table-header">
            <vx-card style="overflow-x: auto;">
                <vs-row>
                  <vs-col class="search-bar" vs-type="flex" vs-justify="right" vs-align="center">
                      <vs-input ref="searchTxt" icon-no-border icon="icon-search" icon-pack="feather" class="w-full input-rounded-full" placeholder="Pencarian berdasarkan tanggal order/no lab/nama pasien" v-model="searchText"  v-on:keyup.enter="search"  v-on:keyup.tab="searchTabClick"/>
                      <vs-tooltip text="Cetak Barcode" v-if="btnBarcode===true">
                          <vs-button radius size="large" type="border" color="#828282" icon="calendar_view_day" class="ml-3"></vs-button>
                      </vs-tooltip>
                      <vs-tooltip text="Mulai Pemeriksaan" v-if="btnStart===true">
                          <vs-button radius size="large" type="border" color="#2a8619" icon="label" class="ml-3" @click="start"></vs-button>
                      </vs-tooltip>
                      <vs-tooltip text="Entri Data" v-if="btnEntry===true">
                          <vs-button radius size="large" type="border" color="#2dadb9" icon="library_books" class="ml-3" @click="entry"></vs-button>
                      </vs-tooltip>
                      <vs-tooltip text="Verifikasi" v-if="btnVerify===true">
                          <vs-button radius size="large" type="border" color="#2196f3" icon="thumb_up" class="ml-3" @click="verify"></vs-button>
                      </vs-tooltip>
                      <vs-tooltip text="Validasi" v-if="btnVerifyFin===true">
                          <vs-button radius size="large" type="border" color="#640065" icon="thumb_up" class="ml-3" @click="valid"></vs-button>
                      </vs-tooltip>
                      <vs-tooltip text="Detail Test" v-if="btnDetail===true">
                          <vs-button radius size="large" type="border" color="#a92299" icon="content_paste" class="ml-3" @click="activePromptWorklist=true;action='Detail';buttonHidden=true"></vs-button>
                      </vs-tooltip>
                      <vs-tooltip text="Cetak PDF" v-if="btnPdf===true">
                          <vs-button radius size="large" type="border" color="#5d9fc6" icon="print" class="ml-3" @click="printPDF"></vs-button>
                      </vs-tooltip>
                      <vs-tooltip text="Edit" v-if="btnEdit===true">
                          <vs-button radius size="large" type="border" color="warning" icon="edit" class="ml-3" @click="edit"></vs-button>
                      </vs-tooltip>
                      <vs-tooltip text="Hapus" v-if="btnDel===true">
                          <vs-button radius size="large" type="border" color="danger" icon="delete" class="ml-3" @click="hapus"></vs-button>
                      </vs-tooltip>
                      <vs-tooltip text="Log Instrument" v-if="btnLog===true">
                          <vs-button radius size="large" type="border" color="#634f9f" icon="warning" class="ml-3"></vs-button>
                      </vs-tooltip>
                    </vs-col>
                </vs-row>
            </vx-card>
        </div>

      <vx-card title="Worklist PCR" class="sticky-table-content1 mt-sticky">
        <vs-table
            max-items="20"
            :data="listWorklist"
            :class="showFixedHeader?'sticky-header':''"
            @selected="handleSelected">

            <template slot="thead">
              <vs-th class="vs-lg-1">No Lab</vs-th>
              <vs-th class="vs-lg-2">Status</vs-th>
              <vs-th class="vs-lg-3">Pasien</vs-th>
              <vs-th class="vs-lg-2">Data Lab</vs-th>
              <vs-th class="vs-lg-3">Pemeriksaan</vs-th>
              <vs-th class="vs-lg-1">Operator</vs-th>
            </template>

            <template slot-scope="{data}">
              <tbody :key="indextr" v-for="(tr, indextr) in data">
                <vs-tr :data="tr" :style="tr.id==idSelected?'background: rgba(var(--vs-primary),.1)!important;':(indextr%2==0?'background: transparent!important;':'')">
                    <vs-td class="vs-lg-1 text-center" style="padding-left: 7px !important; padding-right: 7px !important">
                        <b>{{data[indextr].visitNumber}}</b><br/>
                        {{data[indextr].visitDate | formatDate}}<br/>{{data[indextr].externalNumber}}
                    </vs-td>
                    <vs-td class="vs-lg-2 text-center">
                        <span class="flex items-center px-2 py-1 rounded" v-if="data[indextr].testStatusName=='PENDING'">
                          <div class="h-3 w-3 rounded-full mr-2" :class="'bg-warning'"></div>{{data[indextr].testStatusName}}
                        </span>
                        <span class="flex items-center px-2 py-1 rounded" v-if="data[indextr].testStatusName=='STARTED'" >
                          <div class="h-3 w-3 rounded-full mr-2" style="background-color: #2a8619 !important;"></div>{{data[indextr].testStatusName}}
                        </span>
                        <span class="flex items-center px-2 py-1 rounded" v-if="data[indextr].testStatusName=='COMPLETED'" >
                          <div class="h-3 w-3 rounded-full mr-2" style="background-color: #2dadb9 !important;"></div>{{data[indextr].testStatusName}}
                        </span>
                        <span class="flex items-center px-2 py-1 rounded" v-if="data[indextr].testStatusName=='VERIFIED'" >
                          <div class="h-3 w-3 rounded-full mr-2" style="background-color: #2196f3 !important;"></div>{{data[indextr].testStatusName}}
                        </span>
                        <span class="flex items-center px-2 py-1 rounded" v-if="data[indextr].testStatusName=='VERIFIED FINAL'" >
                          <div class="h-3 w-3 rounded-full mr-2" style="background-color: #640065 !important;"></div>{{'VALIDATED'}}
                        </span>
                        <span class="flex items-center px-2 py-1 rounded" v-if="data[indextr].testStatusName=='DELETED'" >
                          <div class="h-3 w-3 rounded-full mr-2" :class="'bg-danger'"></div>{{data[indextr].testStatusName}}
                        </span>
                        <vs-progress :percent="data[indextr].percentage" color="success"></vs-progress>
                    </vs-td>
                    <vs-td class="vs-lg-3">
                        <b>{{data[indextr].patient?data[indextr].patient.name:''}}</b><br/>
                        <label style="font-size: 12px">{{data[indextr].patient.dob | calcAge1}} {{(data[indextr].patient?(' / '+data[indextr].patient.gender.name):'')}}</label>
                    </vs-td>
                    <vs-td class="vs-lg-2 text-center">
                      <b>{{data[indextr].patientTypeName}} | {{data[indextr].priorityName}}</b><br/>
                      <label style="font-size: 12px">{{data[indextr].wardName}}</label>
                    </vs-td>
                    <vs-td class="vs-lg-3 text-center">
                        <span v-if='tr.testNameV2!=null'>
                          <vs-chip :key="'test_name_' + j" v-for="(testName,j) in tr.testNameV2" v-if="j < 4" :color="testName.colorValue">{{testName.name}}</vs-chip>
                      </span>
                    </vs-td>
                    <vs-td class="vs-lg-1 text-center">
                      <ul class="users-liked user-list">
                        <li v-if="tr.testedBy!=null">
                          <vx-tooltip :text="'Inputer: '+tr.testedBy.name" position="bottom">
                              <vs-avatar :src="tr.testedBy.image" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                          </vx-tooltip>
                        </li>
                        <li v-if="tr.verifiedBy!=null">
                          <vx-tooltip :text="'Verifier: '+tr.verifiedBy.name" position="bottom">
                              <vs-avatar :src="tr.verifiedBy.image" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                          </vx-tooltip>
                        </li>
                        <li v-if="tr.verified2By!=null">
                          <vx-tooltip :text="'Validator: '+tr.verified2By.name" position="bottom">
                              <vs-avatar :src="tr.verified2By.image" size="30px" class="border-2 border-white border-solid -m-1"></vs-avatar>
                          </vx-tooltip>
                        </li>
                      </ul>
                    </vs-td>
                </vs-tr>
              </tbody>
            </template>
        </vs-table>
        <vs-pagination class="pagination pagination-warning" :total="totalItem" v-model="page" @input="find"></vs-pagination>
      </vx-card>

      <!--vs-prompt class="w50"
        title="Konfirmasi Pasien Kirim ke Worklist"
        @accept="acceptAlert"
        accept-text="Kirim"
        cancel-text="Batal"
        :active.sync="activePromptWorklist">
         <div>
           <vx-card title="Informasi Pasien">
           <div class="vx-col w-full mt-2 mb-2">
            <vs-row>
              <vs-col vs-w="2">
                <span class="text-md mr-4 mt-3">Nama Pasien</span>
              </vs-col>
              <vs-col vs-w="5">
                <span class="text-md mr-4 mt-3">{{': '+dataPatient.patientName}}</span>
              </vs-col>
              <vs-col vs-w="2">
                <span class="text-md mr-4 mt-3">No MR</span>
              </vs-col>
              <vs-col vs-w="2">
                <span class="text-md mr-4 mt-3">{{': '+dataPatient.nomr}}</span>
              </vs-col>
            </vs-row>
            <vs-row class="mt-6">
              <vs-col vs-w="2">
                <span class="text-md mr-4 mt-3">Tgl Lahir</span>
              </vs-col>
              <vs-col vs-w="5">
                <span class="text-md mr-4 mt-3">{{': '+dataPatient.patientBirthdate+' ('+dataPatient.patientAge+' tahun)'}}</span>
              </vs-col>
              <vs-col vs-w="2">
                <span class="text-md mr-4 mt-3">Jns Kelamin</span>
              </vs-col>
              <vs-col vs-w="2">
                <span class="text-md mt-3">{{': '+(dataPatient.patientSex=='P'?'Laki-Laki':'Perempuan')}}</span>
              </vs-col>
            </vs-row>
           </div>
           </vx-card>
          <vs-divider position="center">
            Test / Pemeriksaan
          </vs-divider>
           <vs-table stripe :data="listTest" style="text-align:center;">
               <template slot="thead">
                   <vs-th>No</vs-th>
                   <vs-th>Test/Pemeriksaan</vs-th>
               </template>

               <template slot-scope="{data}">
                   <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                       <vs-td>
                           {{indextr+1}}
                       </vs-td>
                       <vs-td style="width:80%">
                           {{data[indextr].test}}
                       </vs-td>
                   </vs-tr>
               </template>
           </vs-table>
         </div>
       </vs-prompt-->

       <vs-prompt class="w80"
         style="overflow: auto:"
         :title="action=='Start'?'Konfirmasi Mulai Pemeriksaan Worklist':'Edit Form Worklist'"
         @accept="start"
         :accept-text="action=='Start'?'Mulai Pemeriksaan':'Simpan'"
         cancel-text="Batal"
         color="#6488e4"
         :active.sync="activePromptWorklist">
          <patient :dataPatient="dataPatient" :subm="subm" :action="action" from="WorklistPCR"/>
        </vs-prompt>
    </div>
</template>

<script>
import visit from "@/api/visit";
import Patient from '../Patient';

export default {
  components: {
    Patient
  },
  data() {
    return {
      idSelected: null,
      activePromptWorklist:false,
      dataPatient: {},
      listWorklist: [],
      listTest: [],
      obj: {},
      btnEdit: false,
      btnDel: false,
      btnBarcode: false,
      btnStart: false,
      btnEntry: false,
      btnVerify: false,
      btnVerifyFin: false,
      btnDetail: false,
      btnPdf: false,
      btnLog: false,
			model: {},
			modelt: {},
      buttonHidden: false,
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			},
      subm: false,
      action: '',
      page: 1,
      totalItem: 0,
      searchText: '',
      isUserScrolling: false,
      showFixedHeader: false,
      isMobile: false
    };
  },
  methods: {
    openConfirm(id) {
        this.idSelected = id
        this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: `Confirm`,
            text: 'Anda yakin menghapus data ini ?',
            acceptText: 'Ya',
            cancelText: 'Tidak',
            accept: this.acceptAlert
        })
    },
    acceptAlert() {
    },
		async find(pg) {
      this.page = pg;
			this.model["perPage"] = this.perPage;
      this.model["page"] = pg;
      this.model["lab_section_id"] = 2;

      this.$vs.loading({
        type:'sound',
      });

			const frm = await visit.listWorklistClinic(this.model);
			if (frm.data.status != false) {
				this.listWorklist = frm.data.data;
				this.totalItem = frm.data.maxPage;
			} else {
			   this.listWorklist = [];
      }

      this.$vs.loading.close();
		},
    handleSelected(tr) {
      this.btnEdit =false;
      this.btnBarcode=false;
      this.btnStart=false;
      this.btnEntry=false;
      this.btnVerify=false;
      this.btnVerifyFin=false;
      this.btnDetail=false;
      this.btnPdf=false;
      this.btnLog=false;
      this.idSelected = tr.id;
      this.listWorklist.forEach(element => {
        if (element.id == this.idSelected) {
          this.btnEdit = true;
          this.btnDel = false;
          this.btnBarcode = true;
          this.btnDetail = true;
          if (element.testStatusName == 'PENDING') {
            this.btnStart = true;
            this.btnDel = true;
          } else if (element.testStatusName == 'VERIFIED FINAL') {
            this.btnPdf = true;
            this.btnEdit = false;
          } else if (element.testStatusName == 'VERIFIED') {
            this.btnEntry=true;
            this.btnEdit = true;
            this.btnVerifyFin = true;
          } else if (element.testStatusName == 'COMPLETED') {
            this.btnEdit = true;
            this.btnVerify = true;
            this.btnVerifyFin = true;
          } else if (element.testStatusName == 'STARTED') {
            this.btnEntry=true;
            this.btnVerify=true;
            this.btnVerifyFin = true;
            this.btnPdf=true;
            this.btnDel = true;
          }
        }
      });
    },
		async getDetail(id) {
      this.$vs.loading({
        type:'sound',
      });
			const frm = await visit.getDetailV2(id);
			if (frm.data.status) {
				this.dataPatient= frm.data.data[0];
			}
      this.$vs.loading.close();
		},
    async printPDF() {
      this.$vs.loading({
        type:'sound',
      });
      const frm = await visit.getDetailV2(this.idSelected);
      if (frm.data.status) {
        this.$vs.loading.close();
        this.$router.push({name: 'pcr-pdf', params: frm.data.data[0]});
      }
    },
    start() {
      if (this.idSelected) {
        this.$router.push({name: 'worklist-start', params: {id: this.idSelected, from: 'pcr', action: 'Start'}});
      }
		},
    edit() {
      if (this.idSelected) {
        this.$router.push({name: 'worklist-start', params: {id: this.idSelected, from: 'pcr', action: 'Update'}});
      }
    },
    hapus() {
      if (this.idSelected) {
        this.$router.push({name: 'worklist-start', params: {id: this.idSelected, from: 'pcr', action: 'Delete'}});
      }
    },
    entry() {
      if (this.idSelected) {
        this.$router.push({name: 'worklist-entry', params: {id: this.idSelected, from: 'pcr'}});
      }
    },
    verify() {
      if (this.idSelected) {
        this.$router.push({name: 'worklist-verify', params: {id: this.idSelected, from: 'pcr'}});
      }
    },
    valid() {
      if (this.idSelected) {
        this.$router.push({name: 'worklist-valid', params: {id: this.idSelected, from: 'pcr'}});
      }
    },
    handleScroll(ev) {
      if(!this.isMobile) {
          this.isUserScrolling = (window.scrollY > 0);
          if (this.isUserScrolling) {
              if (window.pageYOffset > 45) {
                  this.showFixedHeader = true;
              } else {
                  this.showFixedHeader = false;
              }
          } else {
              this.showFixedHeader = false;
          }
      }
    },
    setFocusOnInput(inputName) {
       /**
        * @see https://vuejs.org/v2/api/#vm-el
        * @see https://vuejs.org/v2/api/#vm-refs
        */
        // you could just call this.$refs[inputName].focusInput() but i'm not shure if it belongs to the public API
        let inputEl = this.$refs[inputName].$el.querySelector('input');
        console.log(inputEl.focus);
        inputEl.focus();
    },
    isMobileDevice() {
        const toMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i
        ];

        console.log(navigator.userAgent);

        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    }
  },
  computed: {
  },
  mounted() {
    this.isMobile = this.isMobileDevice();
  },
  created() {
      document.addEventListener('scroll', this.handleScroll);
      this.$nextTick(() => this.setFocusOnInput('searchTxt'))
  },
  destroyed() {
      document.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss">
.w50 .vs-dialog {
    max-width:50%;
}

.w80 .vs-dialog {
    max-width:80%;
}
</style>
